import { CUBE_AGGREGATE_INTERACTION, CUBE_AGGREGATE_INTERACTION_PRODUCT } from '@/api/hcp/interaction/types';
import { Channel } from '@/models/channelFocus';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { useChannelFocusStore } from '@/pages/ChannelFocus/store/useChannelFocusStore';
import { GetOptionsQueryFunction, LimitedQuery } from '@/types/cube';
import { FilterConfig } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';
import { Filter } from '@cubejs-client/core';

const LOCAL_PRODUCT_OPTIONS: GetOptionsQueryFunction = ({ sourceCube, dateRange }) => {
  const timeDimensions = getDateRangeTimeDimension({
    dateRange,
    dimension: `${CUBE_AGGREGATE_INTERACTION}.interaction_date`,
  });

  const baseFilters: Filter[] = [
    { member: `${CUBE_AGGREGATE_INTERACTION}.hcp_bk`, operator: 'set' },
    { member: `${sourceCube}.product`, operator: 'set' },
  ];

  const query: LimitedQuery = {
    dimensions: [`${sourceCube}.product`],
    limit: 1000,
    filters: baseFilters,
    timeDimensions: [timeDimensions],
  };

  const store = useChannelFocusStore.getState();
  const channelValue = store?.channel;

  if (channelValue === Channel.VISITS_1_TO_1) {
    baseFilters.push({
      member: `${CUBE_AGGREGATE_INTERACTION}.is_1to1visit`,
      operator: 'equals',
      values: ['1'],
    });
  } else if (channelValue === Channel.EMAIL) {
    baseFilters.push({
      member: `${CUBE_AGGREGATE_INTERACTION}.channel`,
      operator: 'equals',
      values: ['Email'],
    });
  } else if (channelValue === Channel.EVENT) {
    baseFilters.push({
      member: `${CUBE_AGGREGATE_INTERACTION}.is_invitation`,
      operator: 'equals',
      values: ['1'],
    });
  } else if (channelValue === Channel.WEBSITE) {
    baseFilters.push({
      member: `${CUBE_AGGREGATE_INTERACTION}.is_website_visit`,
      operator: 'equals',
      values: ['1'],
    });
  }

  return query;
};

const localProductFilter: FilterConfig = {
  label: 'main.channelFocus.hcpCoverage.filters.localProduct.label',
  placeholder: 'main.channelFocus.hcpCoverage.filters.localProduct.placeholder',
  type: 'multiselect',
  searchable: true,
  clearable: true,
  getOptionsQuery: LOCAL_PRODUCT_OPTIONS,
  sourceCube: CUBE_AGGREGATE_INTERACTION_PRODUCT,
  mapResult: mapDimensionToOption(`${CUBE_AGGREGATE_INTERACTION_PRODUCT}.product`),
  defaultValue: [],
  applyFilter: value => {
    const products = value as string[];
    return {
      member: `${CUBE_AGGREGATE_INTERACTION_PRODUCT}.product`,
      operator: 'equals',
      values: [...products],
    };
  },
};

export default localProductFilter;
